import { Select } from 'antd';
import React, { useMemo } from 'react';
import { FieldSelectProps } from './type';

const { Option } = Select;

const CompSelect: React.FC<FieldSelectProps> = ({
    id,
    placeholder = __('请选择'),
    onChange,
    value,
    data = [],
    size,
    notFoundContent,
    className,
    renderInComponent,
    dropdownHeader,
    onSearch,
    showSearch,
    ...rest
}) => {
    const memoId = useMemo(() => {
        return id || `field-select${Math.random().toString().slice(-6)}`;
    }, [id]);

    return (
        <div className={className} id={memoId}>
            <Select
                {...rest}
                size={size!}
                style={{ width: '100%' }}
                value={value}
                onChange={onChange}
                showSearch={showSearch}
                onSearch={onSearch}
                filterOption={onSearch ? false : true}
                notFoundContent={notFoundContent}
                placeholder={placeholder}
                optionFilterProp="children"
                getPopupContainer={renderInComponent ? () => document.getElementById(memoId)! : undefined}
                popupClassName="field-select-popup"
                dropdownRender={menu => (
                    <>
                        {dropdownHeader && <div className="sticky-top-content">{dropdownHeader}</div>}
                        {menu}
                    </>
                )}>
                {data.map(item =>
                    item.extraLabel ? (
                        <Option
                            key={item.key || item.value}
                            value={item.value}
                            disabled={item.disabled}
                            className="extra-option">
                            {item.extraLabel}
                        </Option>
                    ) : (
                        <Option key={item.key || item.value} value={item.value} disabled={item.disabled}>
                            <span className="option-item">
                                <span className="d-flex align-items-center">
                                    {item.icon && <img className="select-option-icon" src={item.icon} alt="icon" />}
                                    <span className="option-label">{item.label}</span>
                                </span>
                                {item.disabled && item.disabledDesc && (
                                    <p className="fs-12 mb-0">{item.disabledDesc}</p>
                                )}
                            </span>
                        </Option>
                    )
                )}
            </Select>
        </div>
    );
};

export default CompSelect;
